<button class="close-button" mat-icon-button [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
</button>
<div>
    <p [innerHTML]="html | safeHTML"></p>
</div>

